export const useRecommendationPage = () => {
  const locale = useI18n().locale

  const fetchAnalyticsTable = async () => {
    const cacheKey = `stock-recommendations-analytics-${locale.value}`
    const { data } = await useAsyncData(cacheKey, async () => {
      const response = await $fetch('/api/v1/contentful/investor/table', {
        query: {
          locale: locale.value,
          tableId: 'analytics-table',
        },
      })

      return {
        ...response,
      }
    })

    return data
  }

  const fetchRecommendationPage = async (page: number) => {
    const cacheKey = `stock-recommendations-page-${locale.value}-${page}`

    const { data } = await useAsyncData(cacheKey, async () => {
      try {
        const recommendations = await $fetch('/api/v1/contentful/investor/stock-recommendations', {
          query: {
            locale: locale.value,
            page,
          },
        })

        return {
          ...recommendations,
        }
      } catch (error) {
        console.error(error)
        return {
          recommendations: [],
        }
      }
    })

    return data
  }

  return {
    fetchAnalyticsTable,
    fetchRecommendationPage,
  }
}
